import {
    PortfolioSummarySharedConfigurationState,
    initialPortfolioSummarySharedConfigurationState,
} from './PortfolioSummarySharedConfigurationState';
import {
    WidgetLoadConfigAction,
    WidgetSetConfigAction,
} from 'widgets/store/configuration/actions';
import {
    WidgetActionType,
    isSetOrLoadConfigActionFor,
} from 'widgets/store/actions';
import { WidgetType } from 'widgets/WidgetType';
import { PortfolioSummaryConfigurationState } from '../instances/configuration/PortfolioSummaryConfigurationState';
import { WidgetSetSharedConfigAction } from 'widgets/store/sharedConfiguration/actions';
import { Reducer } from 'redux';
import { createSharedConfigurationReducer } from 'widgets/store/sharedConfiguration/utils.ts';

const widgetSharedConfigurationReducer =
    createSharedConfigurationReducer<PortfolioSummarySharedConfigurationState>(
        WidgetType.PORTFOLIO_SUMMARY,
        initialPortfolioSummarySharedConfigurationState
    );

export const portfolioSummarySharedConfigurationReducer: Reducer<
    PortfolioSummarySharedConfigurationState,
    | WidgetSetConfigAction<PortfolioSummaryConfigurationState>
    | WidgetLoadConfigAction<PortfolioSummaryConfigurationState>
    | WidgetSetSharedConfigAction<PortfolioSummarySharedConfigurationState>
> = (state = initialPortfolioSummarySharedConfigurationState, action) => {
    switch (action.type) {
        case WidgetActionType.WIDGET_SET_SHARED_CONFIG:
            return widgetSharedConfigurationReducer(state, action);
        case WidgetActionType.WIDGET_LOAD_CONFIG:
        case WidgetActionType.WIDGET_SET_CONFIG: {
            if (
                !isSetOrLoadConfigActionFor(
                    WidgetType.PORTFOLIO_SUMMARY,
                    action
                )
            ) {
                return state;
            }
            if (action!.payload!.configDelta.aggregationField) {
                return {
                    recentlyUsedAggregationFields: [
                        action!.payload!.configDelta.aggregationField,
                        ...state.recentlyUsedAggregationFields.filter(
                            (f) =>
                                f !==
                                action!.payload!.configDelta.aggregationField
                        ),
                    ].slice(0, 5),
                };
            }
        }
    }

    return state;
};
